"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WizardStep = void 0;
var _react = _interopRequireDefault(require("react"));
var _useWizardContext2 = require("./useWizardContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var WizardStep = function WizardStep(_ref) {
  var order = _ref.order,
    children = _ref.children,
    className = _ref.className;
  var _useWizardContext = (0, _useWizardContext2.useWizardContext)(),
    step = _useWizardContext.step,
    unmountOnStepChange = _useWizardContext.unmountOnStepChange;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: step !== order ? 'd-none' : className !== null && className !== void 0 ? className : ''
  }, step === order ? children : unmountOnStepChange ? null : children);
};
exports.WizardStep = WizardStep;